import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const StyledText = styled.div`
    margin-bottom: 10px;
    font-size: 14px;
`;

const NoResults = (props) => {
    const {
        label,
        translate,
    } = props;

    return (
        <StyledText>
            {
                utils.isFunction(label) ? label : translate(label)
            }
        </StyledText>
    );
};

NoResults.defaultProps = {
    isLabelTranslated: false,
};

NoResults.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]).isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(NoResults);



// WEBPACK FOOTER //
// ./src/components/form/styling/NoResults.js